<template>
	<v-navigation-drawer touchless v-model="drawer" absolute dark id="main-sidebar" :mini-variant="mini" :disable-route-watcher="true" permanent>
		<v-list-item class="px-2" @click="toggleDrawer" >
			<img class="pa-1 mr-3" width="40px" src="../../assets/img/logo.png"/>
			<v-list-item-title>  </v-list-item-title>
			<v-btn icon @click.stop="mini = !mini">
				<v-icon>mdi-chevron-left</v-icon>
			</v-btn>
		</v-list-item>

		<v-divider color="white"></v-divider>

		<v-list dense v-if="views[view].navigation">
			<v-list-item
			v-for="item in views[view].navigation"
			:key="item.text"
			link
			:to="item.to"
			>

			<v-list-item-icon>
				<v-tooltip right :disabled="!mini">
					<template v-slot:activator="{ on }">
						<v-icon v-on="on">{{ item.icon }}</v-icon>
					</template> 
					<span>{{ item.text }}</span>
				</v-tooltip>   
			</v-list-item-icon>

			<v-list-item-content>
				<v-list-item-title class="font-weight-light">{{ item.text }}</v-list-item-title>
			</v-list-item-content>
		</v-list-item>
	</v-list>


	<v-divider color="white"  v-if="views[view].navigation"></v-divider>
	<v-list dense>
		<v-list-item v-if="loggedIn" link to="/profile">
			<v-list-item-icon>
				<v-tooltip right :disabled="!mini">
					<template v-slot:activator="{ on }">
						<v-icon v-on="on">mdi-account</v-icon>
					</template> 
					<span>Profile</span>
				</v-tooltip>   
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title class="font-weight-light">Profile</v-list-item-title>
			</v-list-item-content>
		</v-list-item>
		<v-list-item>
			<v-list-item-icon>
				<v-tooltip right :disabled="!mini">
					<template v-slot:activator="{ on }">
						<a style="text-decoration: none" href="https://m.works"><v-icon v-on="on">mdi-information-outline</v-icon></a>
					</template> 
					<span>About Meisterworks</span>
				</v-tooltip>   
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title class="font-weight-light">Meisterworks Homepage</v-list-item-title>
			</v-list-item-content>
		</v-list-item>
		<v-dialog v-model="dialog" width="360" v-if="loggedIn" >
			<template v-slot:activator="{ on }">
				<v-list-item v-on="on">
					<v-list-item-icon>
						<v-tooltip right :disabled="!mini">
							<template v-slot:activator="{ on }">
								<v-icon v-on="on">mdi-logout-variant</v-icon>
							</template> 
							<span>Log out</span>
						</v-tooltip>        
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="font-weight-light">Log out</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</template>
			<v-card>
				<v-card-title>Log out</v-card-title>
				<v-card-text>
					Are you sure you want to log out?
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="logout">
						Log Out
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>    
	</v-list>


</v-navigation-drawer>	
</template>

<script>
	import Vuex	from "vuex";
	export default{ 
		name: "Navigation", 
		data: () => {
			return {
				mini: true,
				drawer: false,
				views: {
					visitor: {

					},
					admin: {
						redirect: "home", 
						navigation: [
						{
							text: "Dashboard", 
							to: "/",
							icon: "mdi-home"
						},        
						{
							icon: 'mdi-folder-information',
							text: 'Projects',
							to: {
								name: "view",
								params: { 
									type: "projects", 
								},
							},
						},     
						{
							icon: 'mdi-comment-account',
							text: 'Panelists',
							to: {
								name: "view",
								params: { 
									type: "panelists", 
								},
							},
						},
						{
							icon: 'mdi-account-tie',
							text: 'Clients',
							to: {
								name: "view",
								params: { 
									type: "clients"
								},
							},
						},       
						{
							icon: 'mdi-account-circle',
							text: 'Admins',
							to: {
								name: "view",
								params: { 
									type: "admins"
								},
							},
						},        
						{
							icon: 'mdi-domain',
							text: 'Organisations',
							to: {
								name: "view",
								params: { 
									type: "organisations", 
								},
							},
						},                       
						{
							icon: 'mdi-file-plus-outline',
							text: 'Requests',
							to: {
								name: "view",
								params: { 
									type: "requests", 
								},
							},
						},                
						{
							icon: 'mdi-frequently-asked-questions',
							text: 'Surveys',
							to: {
								name: "view",
								params: { 
									type: "surveys", 
								},
							},
						},          
						{
							icon: 'mdi-pencil-box-multiple',
							text: 'Content',
							to: {
								name: "view",
								params: { 
									type: "posts", 
								},
							},
						}, 
						{
							icon: 'mdi-format-list-checks', 
							text: "Tasks", 
							to: {
								name: "system-tasks", 
								params: {}
							}
						} 



						]
					},
					client: {
						redirect: "home",
						navigation: [
						{
							text: "Home",
							to: "/",
							icon: "mdi-home"
						},
						{
							text: "Projects",
							to: {
								name: "view",
								params: { 
									type: "projects", 
									props: { 
										import: false 
									}
								},
							},            
							icon: "mdi-folder-information"
						},
						{
							text: "New Request",
							to: {
								name: "new-request",
							},            
							icon: "mdi-plus-outline"
						},
						{
							text: "Requests",
							to: {
								name: "view",
								params: { 
									type: "requests"
								},
							},            
							icon: "mdi-file-document-box-multiple-outline"
						}
						]
					},
					panelmember: { 
						redirect: "home",
						navigation: [
						{
							text: "Home",
							to: "/",
							icon: "mdi-home"
						}
						]}
					}				
				}
		}, 
		computed: {
			...Vuex.mapState({
				view: state => state.auth.view,
				user: state => state.auth.user,
				userDetails: state => state[state.auth.view].user, 
				loggedIn: state => state.auth.logged_in,
				loggedOut: state => state.auth.logged_out
			}),
		},
		methods: {
			toggleDrawer: function(){
				this.mini = !this.mini;
				this.drawer = !this.drawer; 
			},			   
			logout: function(){
				this.$store.dispatch('logout');
			}, 
		}
	}
</script>